import { Popover, Transition } from '@headlessui/react';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import React, { Fragment } from 'react';
import ExploreSection from './ExploreSection';
import HighlightedSection from './HighlightedSection';

type Props = {
  menuItem: any,
  title: any,
}

export default function SubMobileMegaMenu({ menuItem, title }: Props) {
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const { exploreTitle, exploreLinks, highlightedSections } = menuItem;

  return (
    <>
      <Popover.Button
        className="text-black hover:text-darkCyan font-['Open_Sans'] leading-[44px] text-[24px] font-semibold w-fit"
      >
        {title}
      </Popover.Button>
      <Transition
        as={Fragment}
        enter="transition ease-in duration-500"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition ease-out duration-500"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
      >
        <Popover.Panel className="absolute inset-0 w-full h-screen overflow-x-hidden overflow-y-auto text-black bg-white -top-12 lg:w-full z-[60]">
          <div className="flex flex-col mt-12 ml-5">
            <Popover.Button className="flex w-fit items-center mb-5 text-[20px] font-semibold text-dimGray">
              <ArrowLeftIcon className="mr-1" width={20} />
              <div className="">{title}</div>
            </Popover.Button>
            <ExploreSection
              title={exploreTitle}
              links={exploreLinks}
            />
            <div className="flex flex-wrap w-full mt-5">
              {highlightedSections
                && highlightedSections.map((item: any) => (
                  <HighlightedSection
                    key={item.id}
                    highlightedSection={item}
                  />
                ))}
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </>
  );
}
